import BaseStore from 'vendor/cnpm/fluxible.v0-4/addons/BaseStore';

import type { AuthoringState as AuthoringStateType } from 'bundles/author-common/constants/AuthoringState';
import AuthoringState from 'bundles/author-common/constants/AuthoringState';

// @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
const authoringStateObjects = Object.keys(AuthoringState).map((stateName) => AuthoringState[stateName]);

/**
 * The `AuthoringStateStore` class is responsible for managing the state of authoring processes
 * within the application. It extends the `BaseStore` class and provides functionality to handle
 * course and item authoring states, as well as the visibility of a breaking changes modal.
 *
 */
class AuthoringStateStore extends BaseStore {
  declare courseState: AuthoringStateType;

  declare itemState: AuthoringStateType;

  declare showBreakingChangesModal: boolean;

  declare courseStateTimeout: NodeJS.Timeout | null;

  declare itemStateTimeout: NodeJS.Timeout | null;

  static storeName = 'AuthoringStateStore';

  constructor(dispatcher: $TSFixMe) {
    super(dispatcher);

    this.courseState = AuthoringState.Idle;
    this.itemState = AuthoringState.Idle;
    this.showBreakingChangesModal = false;

    // Used to timeout to the Authoring.Idle state after it hasn't been there
    this.itemStateTimeout = null;
    this.courseStateTimeout = null;
  }

  toggleBreakingChangesModal({ showModal }: $TSFixMe) {
    this.showBreakingChangesModal = showModal;
    this.emitChange();
  }

  getCourseState() {
    return this.courseState;
  }

  getItemState() {
    return this.itemState;
  }

  getBreakingChangesModalEnabled() {
    return this.showBreakingChangesModal;
  }

  static handlers = {
    SET_COURSE_STATE: 'setCourseState',
    SET_ITEM_STATE: 'setItemState',
    TOGGLE_BREAKING_CHANGES_MODAL: 'toggleBreakingChangesModal',
  };

  setCourseState({ state }: { state: AuthoringStateType }) {
    if (state && state.id >= 0 && authoringStateObjects.find((obj) => obj.id === state.id)) {
      this.courseState = state;
      this.emitChange();
    } else {
      throw new Error('Tried setting course authoring state to something invalid.');
    }
  }

  setItemState({ state }: { state: AuthoringStateType }) {
    if (state && state.id >= 0 && authoringStateObjects.find((obj) => obj.id === state.id)) {
      this.itemState = state;
      this.emitChange();

      if (state.id === AuthoringState.Published.id) {
        if (this.itemStateTimeout) {
          clearTimeout(this.itemStateTimeout);
        }
        this.itemStateTimeout = setTimeout(() => {
          this.itemState = AuthoringState.Idle;
          this.emitChange();
        }, 10000);
      }
    } else {
      throw new Error('Tried setting item authoring state to something invalid.');
    }
  }
}

export default AuthoringStateStore;

export type AuthoringStateStoreType = {
  getItemState: () => AuthoringStateType;
  getCourseState: () => AuthoringStateType;
};
